import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { Busqueda, Candidatos } from 'src/app/interfaces/candidatos';
import { Categorias } from 'src/app/interfaces/categorias';
import { CandidatosService } from 'src/app/services/candidatos/candidatos.service';
import { InicioService } from 'src/app/services/inicio/inicio.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-candidates',
  templateUrl: './candidates.component.html',
  styleUrls: ['./candidates.component.scss']
})
export class CandidatesComponent implements OnInit {

 public mostrarSueldos: boolean
 public mostrarCategorias: boolean
 mostrarAnioExperiencia: boolean;

 verArchivos: string;
 categoriasCandidatos: Categorias[];
 candidatos: Candidatos[];
 salarioInicio: number;
 idEstadoInicio: number;
 cantidadCandidatos: number;
 noPagina: number;
 titulo = new FormControl();
 pais = new FormControl();
 idCategoria: number;
 mensajeError: string;
 mensajeErrorBusc:string;

  constructor(private title: Title, private meta: Meta, private candidatoSerive: CandidatosService, 
    private scroll: ViewportScroller, private inicioService: InicioService) {
      this.agregarMetaData();
      this.mostrarSueldos = false
      this.mostrarAnioExperiencia = false;
      this.mostrarCategorias = false
      this.cantidadCandidatos = 8;
      this.idCategoria = 0;
      this.verArchivos = environment.baseArchivos;
  }

  ngOnInit() {
    this.obtenerCategorias();
    const salarioTemporal: any = localStorage.getItem("salario");
      if (salarioTemporal != null) {
        this.obtenerCandidatos(salarioTemporal);
      }else{
         this.salarioInicio = 0;
        this.idEstadoInicio = 0;
         this.obtenerCandidatos(this.salarioInicio)
      }
  }

  private agregarMetaData(): void {
    this.title.setTitle('Candidatos');
    this.meta.updateTag({name: "description", content: "Encuentra el mejor talento acorde a tus necesidades para tu puesto de trabajo requerido."});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "perfil, candidato, empresa, información, candidato, detalles"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Crear Cuenta Para Empresas"});
    this.meta.updateTag({property: "og:description", content: "Encuentra el mejor talento acorde a tus necesidades para tu puesto de trabajo requerido."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Crear Cuenta Para Empresas"});
    this.meta.updateTag({name: "twitter:description", content:"Encuentra el mejor talento acorde a tus necesidades para tu puesto de trabajo requerido."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  async obtenerCandidatos(salario: number){
    try {
      const response = await this.candidatoSerive.obtenerCandidatos(salario);
      this.candidatos= response.data;
      if(this.candidatos){
        this.noPagina = 1;
        this.candidatos.forEach(candidato =>
        candidato.imagen = (candidato.imagen != environment.candidatoDefault ? this.verArchivos + candidato.imagen : candidato.imagen));
      }

      if(this.candidatos.length == 0 ){
        this.mensajeError = "Lo sentimos no se encontro ningun usuario "
        setTimeout(() => {
            this.mensajeError = "" as string;
          }, 4000);
    }
    } catch (error) {
      console.error("Error al obtener candidatos", error);
    }
  }

  async obtenerCandidatosExperiencia(tiempoExperiencia: number){
    try {
      const response = await this.candidatoSerive.obtenerCandidatosExperiencia(tiempoExperiencia);
      this.candidatos= response.data;
      if(this.candidatos){
        this.noPagina = 1;
        this.candidatos.forEach(candidato =>
        candidato.imagen = (candidato.imagen != environment.candidatoDefault ? this.verArchivos + candidato.imagen : candidato.imagen));
      }
      if(this.candidatos.length == 0 ){
        this.mensajeError = "Lo sentimos no se encontro ningun usuario "
        setTimeout(() => {
            this.mensajeError = "" as string;
          }, 4000);
    }
    } catch (error) {
      console.error("Error al obtener candidatos por experiencia", error);
    }
  }

  async obtenerCategorias(){
    try {
      const response = await this.inicioService.obtenerCategoriasEmpresas();
      this.categoriasCandidatos = response.data;
    } catch (error) {
      console.error("Error al obtener las categorías", error);
    }
  }

  async obtenerCandidatosNuevos(){
    try {
        const response = await this.candidatoSerive.obtenerCandidatosNuevos();
        this.candidatos= response.data;
        this.noPagina = 1;
        this.mostrarSueldos = false;
        this.mostrarAnioExperiencia = false;
        this.candidatos.forEach(candidato =>
            candidato.imagen = (candidato.imagen != environment.candidatoDefault ? this.verArchivos + candidato.imagen : candidato.imagen));
      } catch (error) {
        console.error("Error al obtener candidatos", error);
      }
  }

  async obtenerCandidatosDestacados(){
    try {
        const response = await this.candidatoSerive.obtenerCandidatosDestacados();
        this.candidatos= response.data;
        this.noPagina = 1;
        this.mostrarSueldos = false;
        this.mostrarAnioExperiencia = false;
        this.candidatos.forEach(candidato =>
            candidato.imagen = (candidato.imagen != environment.candidatoDefault ? this.verArchivos + candidato.imagen : candidato.imagen));
      } catch (error) {
        console.error("Error al obtener candidatos", error);
      }
  }

  async obtenerCandidatosPalabraClave(buscador: Busqueda){
    try {
        const response = await this.candidatoSerive.obtenerCandidatosPalabraClave(buscador);
        this.candidatos= response.data;
        this.noPagina = 1;
        if(this.candidatos.length == 0 ){
            this.mensajeError = "Lo sentimos no se encontro ningun usuario con esas especificaciones."
            setTimeout(() => {
                this.mensajeError = "" as string;
              }, 4000);
        }
        this.titulo.setValue("")
        this.pais.setValue("");
        this.idCategoria=0;
        this.candidatos.forEach(candidato =>
            candidato.imagen = (candidato.imagen != environment.candidatoDefault ? this.verArchivos + candidato.imagen : candidato.imagen));
        this.scrollCandidato();
      } catch (error) {
        console.error("Error al obtener candidatos", error);
      }
  }

  seleccionarSalario(salario: number){
    const salarioTemporal: any = localStorage.getItem("salario");
    if (salarioTemporal) {
        localStorage.removeItem("salario")
    }
    localStorage.setItem("salario",salario.toString());
    this.ngOnInit();
  }

  seleccionarExperiencia(tiempoExperiencia: number){
    const tiempoExperienciaTemp: any = localStorage.getItem("tiempoExperiencia");
    if (tiempoExperienciaTemp) {
        localStorage.removeItem("tiempoExperiencia")
    }
    localStorage.setItem("tiempoExperiencia",tiempoExperiencia.toString());
    this.obtenerCandidatosExperiencia(tiempoExperiencia);
  }

  seleccionarIdEstado(idEstado: number){
    const idEstadoTemporal: any = localStorage.getItem("idEstado");
    const salarioTemporal = 0;
    localStorage.setItem("salario",salarioTemporal.toString());
    if (idEstadoTemporal) {
        localStorage.removeItem("idEstado")
    }
    localStorage.setItem("idEstado",idEstado.toString());
    this.ngOnInit();
  }

  selecSueldos(){
      this.mostrarSueldos = !this.mostrarSueldos
      this.mostrarAnioExperiencia = false;
  }

  selecExperiencia(){
    this.mostrarAnioExperiencia = !this.mostrarAnioExperiencia
    this.mostrarSueldos = false;
  }

  selecAll(){
      this.mostrarSueldos = false;
      this.mostrarAnioExperiencia = false;
      const salarioTemporal = 0;
      localStorage.setItem("salario",salarioTemporal.toString());
      const idEstadoTemporal = 0;
      localStorage.setItem("idEstado",idEstadoTemporal.toString());
      this.ngOnInit();

  }


  onSelect(id: number){
    this.idCategoria = id;
    //this.seleccionarIdEstado(id);
  }

  getPalabra(){
    const buscador: Busqueda = {
        palabra : this.titulo.value,
        pais : this.pais.value,
        idCategoria: this.idCategoria
    }
    if(buscador.palabra != null || buscador.pais != null
        || buscador.idCategoria != 0){
        this.obtenerCandidatosPalabraClave(buscador);
    }else{
        this.mensajeError = "Tienes que llenar algun campo para realizar la busqueda"
        setTimeout(() => {
            this.mensajeError = "" as string;
          }, 3000);
    }
  }

  scrollToElement($element): void {
    $element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  scrollCandidato(){
    this.scroll.scrollToAnchor("containerCandidatos");
  }
}
